<!--
tablet 下适配: 去掉时间线, 解放内容区域锁定高度，放大插图
-->
<template>
  <div :class="[$style.news, last && $style.news_last]">
    <div :class="$style.news_wrap">
      <nuxt-link :to="`/news/${data.id}`" target="_blank">
        <div :class="$style.timeline">
          <div :class="$style.timeline_date">
            <i v-if="year" :class="$style.timeline_year">{{ year }}</i>
            <span>{{ day }}</span>
            {{ month }}月
          </div>
        </div>
        <div :class="$style.content">
          <div :class="$style.content_title">{{ data.title }}</div>
          <div :class="$style.content_date">{{ data.date }}</div>
          <div :class="$style.content_brief">
            <p v-html="data.description" />
          </div>
          <span :class="$style.content_detail">查看详细 &rarr;</span>
        </div>
        <div :class="$style.illus">
          <img v-if="data.thumb" v-lazy="lazyImg(data.thumb)" />
          <img v-else src="./images/poster.jpg" />
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    last: { type: Boolean, default: false },
  },
  computed: {
    date() {
      return this.data.date.split('-')
    },
    year() {
      return (this.data.is_show_year === 1 && this.date[0]) || ''
    },
    month() {
      const m = this.date[1]
      return m.startsWith('0') ? m.replace(/^0/, '') : m
    },
    day() {
      return this.date[2]
    },
  },
  methods: {
    lazyImg(src) {
      return {
        src,
        loading: require('./images/loading.jpg'),
      }
    },
  },
}
</script>

<style lang="less" module>
@news-padding-top: 0.55rem;
@news-border-color: #eff1f8;
@news-title-height: 0.28rem;
@news-date-height: 0.32rem;
@line-short-size: 0.66rem;
@line-long-size: 2.32rem;

.news {
  &:hover {
    background-color: #fbfbfb;
  }

  &_wrap {
    height: @line-short-size + @line-long-size;
    margin: 0 3.6rem;

    @media screen and (max-width: @laptop-width) {
      margin: 0 2.6rem;
    }

    @media screen and (max-width: @tablet-width) {
      height: auto;
      margin: 0 1.6rem;
    }

    a {
      display: flex;
      height: 100%;
      text-decoration: none;
    }
  }
}

// 时间线
.timeline {
  flex: 0 0 1.88rem;
  position: relative;
  margin-right: 0.47rem;
  color: #666;

  @media screen and (max-width: @tablet-width) {
    display: none;
  }

  &_date {
    z-index: 1;
    position: absolute;
    top: 0.47rem;
    right: 0;
    padding-right: 0.25rem;
    font-size: 0.14rem;
    white-space: nowrap;

    a:hover & {
      color: @primary;
    }

    span {
      display: inline-block;
      margin-right: 0.02rem;
      font-weight: 700;
      font-size: 0.26rem;
    }

    // 圆点
    &::after {
      .size(0.12rem);
      content: '';
      position: absolute;
      top: 0.14rem;
      right: -0.05rem;
      border: 0.02rem solid #e4e4e4;
      border-radius: 100%;
      background-color: #fff;
      box-sizing: border-box;

      a:hover & {
        border-color: @primary;
        background-color: @primary;
      }
    }
  }

  &_year {
    margin: 0.3em 0.4rem 0 0;
    padding: 0.25em 0.5em;
    border-radius: 0.05rem;
    background-color: #f3f3f3;
    font-style: normal;
    font-weight: 700;
    font-size: 0.16rem;
  }

  // 连接线
  &::before,
  &::after {
    content: '';
    position: absolute;
    right: 0;
    width: 0.02rem;
    background-color: #e4e4e4;
  }

  &::before {
    top: 0;
    height: @line-short-size;

    .news:first-child & {
      content: none;
    }
  }

  &::after {
    bottom: 0;
    height: @line-long-size;

    .news_last & {
      content: none;
    }
  }
}

// 新闻标题及简介
.content {
  flex: 1;
  padding-top: @news-padding-top;
  border-bottom: 1px solid @news-border-color;

  &_title {
    height: @news-title-height;
    font-size: 0.16rem;
    color: #110501;

    a:hover & {
      color: @primary;
    }
  }

  &_date {
    height: @news-date-height;
    color: #696969;
  }

  &_brief {
    height: 0.8rem;
    margin-bottom: 1em;

    p {
      .text-clamp(2);
      line-height: 1.5;
      color: #858585;
    }
  }

  &_detail {
    display: inline-block;
    padding: 0.5em 1.5em;
    border: 0.02rem solid #737373;
    border-radius: 2em;
    font-size: 12px;
    color: #3f3f3f;

    a:hover & {
      border-color: @primary;
      background-color: @primary;
      color: #fff;
    }
  }

  @media screen and (max-width: @laptop-width) {
    &_title {
      font-size: 15px;
    }

    &_date {
      font-size: 12px;
    }

    &_detail {
      padding: 0.25em 1em;
    }
  }

  @media screen and (max-width: @tablet-width) {
    padding-bottom: @news-padding-top;
    line-height: 1.5;

    &_title {
      height: auto;
    }

    &_date {
      height: auto;
    }

    &_brief {
      height: auto;
      margin-bottom: 1.5em;
    }
  }

  @media screen and (max-width: @mini-width) {
    padding: 1.5em 0;

    &_brief {
      font-size: 12px;
    }
  }
}

// 新闻配图
.illus {
  @illus-width: 2.68rem;
  @illus-img-width: 2.23rem;
  @illus-img-height: 1.23rem;

  .illus-size(@r: 1) {
    flex: 0 0 @illus-width * @r;

    img {
      .size(@illus-img-width * @r, @illus-img-height * @r);
    }
  }

  .illus-size();
  border-bottom: 1px solid @news-border-color;
  padding-top: @news-padding-top + @news-title-height + @news-date-height;
  text-align: right;

  @media screen and (max-width: @tablet-width) {
    .illus-size(2);
    padding-top: @news-padding-top;
  }

  @media screen and (max-width: @mobile-width) {
    display: none;
  }
}
</style>
